import React, { useState, forwardRef, useImperativeHandle } from "react";
import { FieldGroup } from "react-reactive-form";
import useQuestions from "../hooks/useQuestions";
import LSForm from "../questions/LSForm";

const LSQuestionsList = forwardRef((props, ref) => {
  const { missingFields } = props;
  const { laySummaryWizardForm } = useQuestions();

  const [globalId] = useState(0);
  const [, setIsSaving] = useState(false);

  // Expose setSavingState function to parent component
  useImperativeHandle(ref, () => ({
    setSavingState: saving => {
      setIsSaving(saving);
    },
  }));

  return (
    <>
      <FieldGroup
        control={laySummaryWizardForm}
        render={() => {
          return (
            <LSForm
              globalId={globalId}
              wizardForm={laySummaryWizardForm}
              missingFields={missingFields}
            />
          );
          // }
        }}
      />
    </>
  );
});

LSQuestionsList.displayName = "LSQuestionsList";

export default LSQuestionsList;
